export default __webpack_public_path__ + "static/media/irclass_logo.ee5f1b92.png";